import { saveAs } from "file-saver";
import { DATE_FORMATS, formatDate } from "../../../services/date-and-time.utils";
import { convertToFullName } from "../../../services/utils";
import {
  formatTargetCompletion,
  getInitiativeTypeDisplayLabel,
} from "../../ambassadors/ambassador-details/initiatives/utils";

function escapeCsvValue(value) {
  if (value == null) return "";
  const str = String(value);
  if (str.includes(",") || str.includes('"') || str.includes("\n")) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

function convertToCsv(headers: string[], rows: string[][]) {
  const lines = [
    headers.map(escapeCsvValue).join(","),
    ...rows.map((row) => row.map(escapeCsvValue).join(",")),
  ];
  return lines.join("\n");
}

const INITIATIVE_EXPORT_HEADERS = [
  "Ambassador",
  "Title",
  "Type",
  "Tool Name",
  "Status",
  "Visibility",
  "Planned delivery",
  "Updated",
  "Summary",
];

function mapInitiativeToExportRow(initiative) {
  return [
    convertToFullName(
      initiative.ambassadorFirstName,
      initiative.ambassadorLastName
    ).trim() || "",
    initiative.title || "",
    getInitiativeTypeDisplayLabel(initiative.type),
    initiative.toolName || "",
    initiative.isActive ? "Active" : "Inactive",
    initiative.isPublic ? "Public" : "Private",
    formatTargetCompletion(initiative.plannedDeliveryDate),
    initiative.updatedAt
      ? formatDate(initiative.updatedAt, DATE_FORMATS.fullDateWithTime)
      : "",
    initiative.summary || "",
  ];
}

function downloadInitiativesListCsv(initiatives: any[] = []) {
  const csvContent = convertToCsv(
    INITIATIVE_EXPORT_HEADERS,
    initiatives.map(mapInitiativeToExportRow)
  );
  const blob = new Blob(["\uFEFF" + csvContent], {
    type: "text/csv;charset=utf-8;",
  });
  const date = new Date().toISOString().slice(0, 10);
  saveAs(blob, `initiatives-${date}.csv`);
}

export { downloadInitiativesListCsv };
